<div class="n-oldalfej">
  <div>
    <h2>Nyomtatványok</h2>
    <span class="n-alcim">{{ aktiv.ugyfelNev || 'nincs kiválasztott ügyfél' }} · dolgozónkénti igazolások és bérjegyzékek a tárolt számfejtésből</span>
  </div>
  <div class="spacer"></div>
  <label class="ev-valaszto">Év
    <select [ngModel]="aktiv.ev" (ngModelChange)="evValt(+$event)"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
  </label>
  <label class="ev-valaszto" *ngIf="lap === 'berjegyzek' || (lap === 'katalogus' && vanHaviIrat)">Hónap
    <select [ngModel]="aktiv.ho" (ngModelChange)="hoValt(+$event)"><option *ngFor="let h of honapok" [ngValue]="h.value">{{ h.label }}</option></select>
  </label>
</div>

<div class="b-fulek">
  <button *ngFor="let f of fulek" type="button" [class.aktiv]="lap === f.k" (click)="lapValt(f.k)">{{ f.c }}</button>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet (Törzsadatok → Ügyfelek).</div>

<ng-container *ngIf="aktiv.ugyfelId">
  <!-- KATALÓGUS: pipált iratok × kijelölt dolgozók, egy nyomtatásban (ber-iratok.ts) -->
  <ng-container *ngIf="lap === 'katalogus'">
    <p class="as-leiras">
      Jelöld ki a nyomtatandó iratokat és a dolgozókat – a <b>Nyomtatás</b> dolgozónként egymás után, egy nyomtatásban adja ki őket
      a tárolt törzsadatból, jelenlétből és számfejtésből. A NAV-nyomtatványok a NAV-bevallásokhoz visznek (kitöltés, ellenőrzés, beküldés).
      A halvány tételek még készülnek.
    </p>
    <div class="kat-racs">
      <div class="n-panel kat-lista">
        <ng-container *ngFor="let c of katalogus; let ci = index">
          <div class="kat-csoport" [class.elso]="ci === 0">{{ c.cim }}</div>
          <ng-container *ngFor="let t of c.tetelek">
            <label class="kat-tetel" *ngIf="t.fajta === 'irat' || t.fajta === 'meglevo'">
              <input type="checkbox" [checked]="kijeloltIratok.has(t.kod)" (change)="iratValt(t, $any($event.target).checked)">
              <span>{{ t.cim }}</span><small class="halvany" *ngIf="t.havi"> · {{ honapCim }}</small></label>
            <a class="kat-tetel kat-nav" *ngIf="t.fajta === 'nav'" (click)="navNyit(t)"><ion-icon name="open-outline"></ion-icon><span>{{ t.cim }}</span></a>
            <div class="kat-tetel kat-keszul" *ngIf="t.fajta === 'keszul'" title="Készül"><input type="checkbox" disabled><span>{{ t.cim }}</span><small> · készül</small></div>
          </ng-container>
        </ng-container>
      </div>
      <div class="n-panel kat-dolgozok">
        <div class="n-szuro-sor" style="padding:0 0 6px">
          <input type="search" [(ngModel)]="dolgozoKereso" placeholder="Dolgozó keresése…">
          <label><input type="checkbox" [(ngModel)]="csakAktivDolgozo"> csak {{ aktiv.ev }}-ben aktívak</label>
          <span class="spacer"></span>
          <button type="button" class="ov-link" (click)="mindDolgozo(true)">mind</button>
          <button type="button" class="ov-link" (click)="mindDolgozo(false)">egyik sem</button>
        </div>
        <div class="kat-dolgozo-lista">
          <label class="kat-tetel" *ngFor="let a of lathatoDolgozok">
            <input type="checkbox" [checked]="kijeloltDolgozok.has(a.id)" (change)="dolgozoValt(a, $any($event.target).checked)">
            <span><b>{{ a.nev }}</b> <small class="halvany">{{ a.adoazonosito || '' }}{{ a.szamfejtes_db ? ' · ' + a.szamfejtes_db + ' számfejtés' : '' }}</small></span></label>
          <div class="ures" *ngIf="!lathatoDolgozok.length"><ion-icon name="people-outline"></ion-icon>Nincs dolgozó a szűréssel.</div>
        </div>
        <div class="kat-lab">
          <span class="halvany">{{ kijeloltIratok.size }} irat · {{ kijeloltDolgozok.size }} dolgozó</span>
          <span class="spacer"></span>
          <button type="button" class="ov-gomb fo" [disabled]="!kijeloltIratok.size || !kijeloltDolgozok.size || !!katalogusFut" (click)="katalogusNyomtat()">
            <ion-icon name="print-outline"></ion-icon>{{ katalogusFut || 'Nyomtatás' }}</button>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ÉVES JÖVEDELEMIGAZOLÁS -->
  <ng-container *ngIf="lap === 'igazolas'">
    <p class="as-leiras">
      A munkáltató összesített igazolása az SZJA-bevalláshoz, a NAV <b>M30</b> nyomtatvány teljes adattartalmával: I. összevont adóalapba
      tartozó jövedelmek (bevétel / költség / jövedelem), II. elkülönülten adózó jövedelmek, III. kedvezmények (605–612.), IV. havi
      kedvezményalap és kedvezmények, V. havi járulékok és családi járulékkedvezmény, VI. szocho. A sorszámok a NAV 25M30 sablonjából
      valók; a 26M30 megjelenéséig a 2026-tól új kedvezmény külön sorban szerepel.
    </p>
    <div class="n-szuro-sor">
      <span class="cimke">{{ igazolas?.igazolasok?.length || 0 }} dolgozó · {{ aktiv.ev }}</span>
      <span class="spacer"></span>
      <button type="button" class="ov-gomb fo" (click)="nyomtatIgazolas()" [disabled]="!igazolas?.igazolasok?.length"><ion-icon name="print-outline"></ion-icon>Összes nyomtatása</button>
    </div>
    <div class="tabla-wrap" *ngIf="igazolas">
      <table class="n-racs">
        <thead><tr>
          <th>Dolgozó</th><th>Adóazonosító</th><th class="num">Hónap</th>
          <th class="num">Összevont jövedelem (22.)</th><th class="num">Kedvezmények</th><th class="num">Levont adóelőleg (65.)</th><th></th>
        </tr></thead>
        <tbody>
          <tr *ngFor="let ig of igazolas.igazolasok">
            <td><b>{{ ig.alkalmazott.nev }}</b> <span class="cimke sarga" *ngIf="ig.tervezet_db">{{ ig.tervezet_db }} tervezet</span></td>
            <td>{{ ig.alkalmazott.adoazonosito || '—' }}</td>
            <td class="num">{{ ig.honapok.length }}</td>
            <td class="num">{{ ig.sorok['22'] | number:'1.0-0' }}</td>
            <td class="num">{{ kedvOssz(ig) | number:'1.0-0' }}</td>
            <td class="num"><b>{{ ig.sorok['65'] | number:'1.0-0' }}</b></td>
            <td class="ber-muv"><button type="button" class="ov-gomb" (click)="nyomtatIgazolas(ig)"><ion-icon name="print-outline"></ion-icon>Nyomtatás</button></td>
          </tr>
        </tbody>
      </table>
      <div class="ures" *ngIf="!igazolas.igazolasok.length"><ion-icon name="document-outline"></ion-icon>{{ aktiv.ev }}-ben nincs számfejtés.</div>
    </div>
  </ng-container>

  <!-- MUNKÁLTATÓI IGAZOLÁS FENNÁLLÓ MUNKAVISZONYRÓL -->
  <ng-container *ngIf="lap === 'munkaltatoi'">
    <p class="as-leiras">
      Igazolás a fennálló munkaviszonyról (pl. hitelkérelemhez, albérlethez, hatósághoz): a jogviszony kezdete és időtartama,
      munkakör, munkaidő, alapbér, az utolsó legfeljebb 6 hónap bruttó és nettó keresete havi átlaggal, és a bért terhelő letiltások.
      A próbaidőt és a felmondási időt a kiállító jelöli a nyomtatványon.
    </p>
    <div class="n-szuro-sor"><span class="spacer"></span><span class="cimke">{{ fennalloJogviszonyok.length }} fennálló jogviszony</span></div>
    <div class="tabla-wrap">
      <table class="n-racs">
        <thead><tr><th>Dolgozó</th><th>Jogviszony</th><th>Munkakör</th><th>Kezdete</th><th>Időtartam</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let j of fennalloJogviszonyok">
            <td><b>{{ j.alkalmazott_nev }}</b></td>
            <td>{{ j.tipus_nev }}</td>
            <td>{{ j.munkakor || '—' }}</td>
            <td>{{ j.kezdet ? (j.kezdet | slice:0:10) : '—' }}</td>
            <td>{{ j.veg ? 'határozott, ' + (j.veg | slice:0:10) + '-ig' : 'határozatlan' }}</td>
            <td class="ber-muv"><button type="button" class="ov-gomb" (click)="nyomtatMunkaltatoi(j)"><ion-icon name="print-outline"></ion-icon>Nyomtatás</button></td>
          </tr>
        </tbody>
      </table>
      <div class="ures" *ngIf="!fennalloJogviszonyok.length"><ion-icon name="briefcase-outline"></ion-icon>Nincs fennálló jogviszony.</div>
    </div>
  </ng-container>

  <!-- KILÉPŐ IGAZOLÁS -->
  <ng-container *ngIf="lap === 'kilepo'">
    <p class="as-leiras">
      A munkaviszony megszűnésekor kiadandó igazolás adatai egy lapon: a jogviszony, a megszűnés évében kiadott szabadság és betegszabadság
      (a jelenléti adatokból), a fennálló letiltások és az utolsó legfeljebb 12 hónap járulékalapja. <b>Belső minta</b> – a hatósági
      formanyomtatványokat nem váltja ki, a kiállítás előtt ellenőrizendő.
    </p>
    <div class="n-szuro-sor">
      <label class="as-kapcs"><input type="checkbox" [(ngModel)]="csakMegszunt"> csak a {{ aktiv.ev }}-ben megszűnt jogviszonyok</label>
      <span class="spacer"></span>
      <span class="cimke">{{ jogviszonyok.length }} jogviszony</span>
    </div>
    <div class="tabla-wrap">
      <table class="n-racs">
        <thead><tr><th>Dolgozó</th><th>Jogviszony</th><th>Munkakör</th><th>Kezdete</th><th>Megszűnése</th><th>Megszűnés módja</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let j of jogviszonyok">
            <td><b>{{ j.alkalmazott_nev }}</b></td>
            <td>{{ j.tipus_nev }}</td>
            <td>{{ j.munkakor || '—' }}</td>
            <td>{{ j.kezdet ? (j.kezdet | slice:0:10) : '—' }}</td>
            <td>{{ j.veg ? (j.veg | slice:0:10) : 'fennáll' }}</td>
            <td>{{ j.kilepes_ok || '—' }} <span class="cimke sarga" *ngIf="j.veg && !j.kilepes_ok">hiányzik</span></td>
            <td class="ber-muv"><button type="button" class="ov-gomb" (click)="nyomtatKilepo(j)"><ion-icon name="print-outline"></ion-icon>Nyomtatás</button></td>
          </tr>
        </tbody>
      </table>
      <div class="ures" *ngIf="!jogviszonyok.length"><ion-icon name="exit-outline"></ion-icon>
        {{ csakMegszunt ? aktiv.ev + '-ben nem szűnt meg jogviszony.' : 'Nincs jogviszony.' }}</div>
    </div>
  </ng-container>

  <!-- HAVI BÉRJEGYZÉK -->
  <ng-container *ngIf="lap === 'berjegyzek'">
    <p class="as-leiras">
      A havi fizetési jegyzék (bérjegyzék) – ugyanaz a bérlap, mint a Béradatok képernyőn, itt egy nyomtatásban a hónap összes dolgozójára
      (dolgozónként egy lap).
    </p>
    <div class="n-szuro-sor">
      <span class="cimke">{{ berlista.sorok.length }} számfejtés · {{ aktiv.ev }}. {{ honapCim }}</span>
      <span class="spacer"></span>
      <label class="bj-kapcs" title="A hónap naptára a napi jelenléti kódokkal"><input type="checkbox" [(ngModel)]="bjOpciok.naptar" (ngModelChange)="bjOpciokMent()"> Naptár</label>
      <label class="bj-kapcs" title="A munkáltató közterhei (szocho / KIVA, kedvezmények, összköltség) tájékoztatásul"><input type="checkbox" [(ngModel)]="bjOpciok.munkaltato" (ngModelChange)="bjOpciokMent()"> Munkáltató által fizetendő</label>
      <button type="button" class="ov-gomb fo" (click)="nyomtatBerjegyzek()" [disabled]="!berlista.sorok.length"><ion-icon name="print-outline"></ion-icon>Összes nyomtatása</button>
    </div>
    <div class="tabla-wrap">
      <table class="n-racs">
        <thead><tr><th>Dolgozó</th><th>Adóazonosító</th><th>Állapot</th><th class="num">Bruttó</th><th class="num">Levonások</th><th class="num">Nettó</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let r of berlista.sorok">
            <td><b>{{ r.alkalmazott_nev }}</b></td>
            <td>{{ r.adoazonosito || '—' }}</td>
            <td><span class="cimke" [class.zold]="r.allapot === 'veglegesitett'" [class.sarga]="r.allapot !== 'veglegesitett'">{{ r.allapot === 'veglegesitett' ? 'véglegesített' : 'tervezet' }}</span></td>
            <td class="num">{{ r.brutto | number:'1.0-0' }}</td>
            <td class="num">{{ (+r.brutto - +r.netto) | number:'1.0-0' }}</td>
            <td class="num"><b>{{ r.netto | number:'1.0-0' }}</b></td>
            <td class="ber-muv"><button type="button" class="ov-gomb" (click)="nyomtatBerjegyzek(r)"><ion-icon name="print-outline"></ion-icon>Nyomtatás</button></td>
          </tr>
        </tbody>
      </table>
      <div class="ures" *ngIf="!berlista.sorok.length"><ion-icon name="document-outline"></ion-icon>Nincs számfejtés ebben a hónapban.</div>
    </div>
  </ng-container>
</ng-container>
